import insightAreaItemConnector from "../insight-area-item-connector"
import InsightAreaViewItem from "./InsightAreaViewItem"

export default insightAreaItemConnector(InsightAreaViewItem)
